<div class="content-box">
  <div class="element-box not-found">
    <h1>403</h1>
    <h5>Keine Berechtigung</h5>
    <h4>Sie haben keine Berechtigung für diese Seite</h4>
    <br />
    <button (click)="goLogin()" class="btn btn-primary">Zum Login</button>
  </div>
</div>
